(function ($) {
    "use strict";


    // back-to-top
    $(window).on('scroll', function () {
        if ($(this).scrollTop() > 600) {
            $('.back-to-top').addClass("topbtn_hide");
        } else {
            $('.back-to-top').removeClass("topbtn_hide");
        }
    });
    $('.back-to-top').on('click', function (event) {
        event.preventDefault();
        $('html, body').animate({
            scrollTop: 0,
        }, 1500);
    });

    $(document).ready(function () {


        // toggleMenuWhite
        function toggleMenuWhite() {
            if ($(window).scrollTop() > 150) {
                $('.site_header').addClass('menu_white');
            } else {
                $('.site_header').removeClass('menu_white');
            }
        }

        // Run on scroll
        $(window).on('scroll', function () {
            toggleMenuWhite();
        });

        // Run on page load (for refresh case)
        toggleMenuWhite();

        // Checkbox
        $(".check").on("click", function () {
            $(this).toggleClass("active");
        });

        // Desktop mega-menu: stay open while the pointer is anywhere inside .site_header.
        // Closing only when leaving the whole header fixes flicker when moving between Surplus → Apparel etc.
        var menuDropdownCloseTimer = null;
        function isDesktopNav() {
            return $(window).width() >= 992;
        }
        function closeDesktopMegaMenu() {
            $('.dropdown_menu.menu_items_dropdown').removeClass('dropdown-hover');
            $('.site_header').removeClass('dropdown_active');
        }
        function closeLanguageSelect() {
            $('.language_select').removeClass('active');
        }
        function closeSearchMenu() {
            $('.search_area').removeClass('search_active');
            $('.site_header').removeClass('search_menu');
        }
        function activateMegaMenu($dropdownMenu) {
            clearTimeout(menuDropdownCloseTimer);
            closeLanguageSelect();
            $('.dropdown_menu.menu_items_dropdown').removeClass('dropdown-hover');
            $dropdownMenu.addClass('dropdown-hover');
            $('.site_header').addClass('dropdown_active');
        }
        $(document).on('mouseenter', '.dropdown_menu.menu_items_dropdown > .menu_link', function () {
            if (!isDesktopNav()) return;
            activateMegaMenu($(this).closest('.dropdown_menu.menu_items_dropdown'));
        });
        $(document).on('mouseenter', '.dropdown_menu.menu_items_dropdown > .dropdown', function () {
            if (!isDesktopNav()) return;
            activateMegaMenu($(this).closest('.dropdown_menu.menu_items_dropdown'));
        });
        $(document).on('mouseleave', '.site_header', function (e) {
            if (!isDesktopNav()) return;
            var to = e.relatedTarget;
            if (to && this.contains(to)) return;
            clearTimeout(menuDropdownCloseTimer);
            menuDropdownCloseTimer = setTimeout(function () {
                closeDesktopMegaMenu();
            }, 120);
        });

        // menu_link - handle dropdown toggling and link navigation
        $(".dropdown_menu, .menu_back").on("click", function (e) {
            var $target = $(e.target);
            var $clickedLink = $target.is('a') ? $target : $target.closest('a');
            var isMobile = $(window).width() < 992; // Match Bootstrap lg breakpoint
            var $dropdownMenu = $(this);
            var isDropdownParent = $dropdownMenu.hasClass('menu_items_dropdown');
            var isMenuBack = $(this).hasClass('menu_back');
            
            // Handle menu back button
            if (isMenuBack) {
                $(this).closest('.dropdown_menu').removeClass('active');
                e.preventDefault();
                return false;
            }
            
            // If clicking on a link
            if ($clickedLink.length > 0) {
                // On mobile: if it's a dropdown parent link, toggle dropdown instead of navigating
                if (isMobile && isDropdownParent && $clickedLink.hasClass('menu_link')) {
                    var isActive = $dropdownMenu.hasClass('active');
                    $dropdownMenu.toggleClass('active');
                    // Close other dropdowns when opening a new one
                    if (!isActive) {
                        $('.dropdown_menu').not($dropdownMenu).removeClass('active');
                    }
                    e.preventDefault();
                    return false;
                }
                // On desktop or non-dropdown links: allow navigation
                // Don't prevent default - let the link navigate
                return true;
            }
            
            // If clicking on the container itself (not a link), toggle it
            var isActive = $dropdownMenu.hasClass('active');
            $dropdownMenu.toggleClass('active');
            // Close other dropdowns when opening a new one
            if (!isActive) {
                $('.dropdown_menu').not($dropdownMenu).removeClass('active');
            }
            e.preventDefault();
        });

        // toggle_mobile_menu
        $(".toggle_mobile_menu").on("click", function () {
            var isActivated = $('.site_header').hasClass('mobile_menu_activated');
            $('.site_header').toggleClass('mobile_menu_activated');
            $('.site_header').removeClass('search_menu');
            
            // Prevent body scroll when menu is open
            if (!isActivated) {
                $('body').addClass('mobile_menu_activated');
            } else {
                $('body').removeClass('mobile_menu_activated');
                // Also close any open dropdowns
                $('.dropdown_menu').removeClass('active');
            }
        });

        // search_toggle
        $(".search_toggle").on("click", function () {
            var willOpen = !$('.search_area').hasClass('search_active');
            if (willOpen) {
                closeDesktopMegaMenu();
                closeLanguageSelect();
            }
            $('.search_area').toggleClass("search_active");
            $('.site_header').toggleClass('search_menu');
        });

        // search_area
        $(".search_area").on("click", function () {
            $('.site_header').removeClass('mobile_menu_activated');
            $('body').removeClass('mobile_menu_activated');
            $('.dropdown_menu').removeClass('active');
        });

        // side_bar_top — delegated: collection facets (desktop + mobile, survives AJAX)
        $(document).on("click", ".ajax-facets-page .sidebar_left_wraps.filter-collapsible > .side_bar_top", function () {
            $(this).closest('.sidebar_left_wraps').toggleClass('active');
            $(this).attr('aria-expanded', $(this).closest('.sidebar_left_wraps').hasClass('active') ? 'true' : 'false');
        });

        // language_select
        $(".language_select").on("click", function (event) {
            event.stopPropagation();
            var willOpen = !$(this).hasClass('active');
            if (willOpen) {
                closeDesktopMegaMenu();
                closeSearchMenu();
            }
            $(this).toggleClass("active");
        });

        // language_select
        $(document).on("click", function (event) {
            if (!$(event.target).closest(".language_select").length) {
                $(".language_select").removeClass("active");
            }
        });

        // search_area
        $(document).on("click", function (event) {
            if (!$(event.target).closest(".search_area").length) {
                $('.search_area').removeClass("search_active");
            }
        });

        // language_list li
        $(".language_list li").on("click", function () {
            var lang = $(this).attr('data-lang');
            $('.selected_language').text(lang);
        });

        // increment_decrement
        $(".increment_decrement").each(function () {
            let $counter = $(this).find(".counter_number");

            $(this).find(".plus_btn").click(function () {
                let count = parseInt($counter.text());
                $counter.text(count + 1);
            });

            $(this).find(".minus_btn").click(function () {
                let count = parseInt($counter.text());
                if (count > 1) {
                    $counter.text(count - 1);
                }
            });
        });

        // toggle_sidebar — delegated: filter drawer markup is re-rendered on facet AJAX (close button is new DOM).
        $(document).on("click", ".toggle_sidebar1", function (event) {
            $('#custom_popup_wrap1').toggleClass("sidebar_toggled");
        });

        $(document).on("click", ".toggle_sidebar2", function (event) {
            $('#custom_popup_wrap2').toggleClass("sidebar_toggled");
        });

        // collapse_radio
        $(".collapse_radio").on("click", function (event) {
            $(this).closest('.radios').find('.radio').removeClass("active");
            $(this).find('.radio').toggleClass("active");
        });

        // faq_llnk2
        $(".faq_llnk2").on("click", function (event) {
            $(this).closest('.faq_menu2').find('.faq_llnk2').removeClass("active");
            $(this).toggleClass("active");
        });

        $(window).on('scroll', function () {
            var scrollPos = $(window).scrollTop();
            var scrollOffset = 120; // Adjust if needed
        
            $('.accordion_wrap').each(function () {
                var currSection = $(this);
                var sectionTop = currSection.offset().top - scrollOffset;
                var sectionBottom = sectionTop + currSection.outerHeight();
        
                if (scrollPos >= sectionTop && scrollPos < sectionBottom) {
                    var id = currSection.attr('id');
                    $('.faq_llnk').removeClass('active');
                    $('.faq_llnk[href="#' + id + '"]').addClass('active');
                }
            });
        });
        
        // Click event for smooth scrolling
        $('.faq_llnk').on('click', function (e) {
            e.preventDefault();
        
            var targetId = $(this).attr('href').substring(1); // Get the ID without #
            var targetSection = $('#' + targetId);
        
            if (targetSection.length) {
                var scrollOffset = 100; // Adjust this value as needed
        
                $('html, body').animate({
                    scrollTop: targetSection.offset().top - scrollOffset
                }, 600, function () {
                    // Activate the link after scroll animation completes
                    $('.faq_llnk').removeClass('active');
                    $('.faq_llnk[href="#' + targetId + '"]').addClass('active');
                });
            }
        });
        


        // uploader
        $(document).ready(function () {
            $('.uploader').on('change', function () {
                var files = this.files;
                var fileLimit = 10;
                var maxFileSize = 10 * 1024 * 1024; // 10MB in bytes
                var fileNames = [];
                var validFiles = [];
        
                if (files.length > fileLimit) {
                    alert('You can only upload up to 10 files.');
                    this.value = ''; // Reset file input
                    return;
                }
        
                for (var i = 0; i < files.length; i++) {
                    if (files[i].size > maxFileSize) {
                        alert(files[i].name + ' exceeds the 10MB limit.');
                    } else {
                        validFiles.push(files[i]);
                        fileNames.push(files[i].name);
                    }
                }
        
                if (validFiles.length > 0) {
                    $('.replace_file_name').text(fileNames.join(', '));
                } else {
                    $('.replace_file_name').text('Attach up to 10 files. Max file size: 10 MB');
                }
            });
        });

        /* Explore area / video thumbnail: Magnific iframe popup (delegated — works with Theme Editor + any video URL shape). */
        function normalizeExploreVideoSrc(href) {
            if (!href) return '';
            try {
                var u = String(href).trim();
                var m;

                if (/youtube\.com\/embed\//i.test(u)) {
                    return u.indexOf('autoplay') === -1
                        ? u + (u.indexOf('?') === -1 ? '?' : '&') + 'autoplay=1'
                        : u;
                }

                m = /youtu\.be\/([^?&#]+)/i.exec(u);
                if (m) return 'https://www.youtube.com/embed/' + m[1] + '?autoplay=1';

                m = /youtube\.com\/shorts\/([^?&#]+)/i.exec(u);
                if (m) return 'https://www.youtube.com/embed/' + m[1] + '?autoplay=1';

                m = /[?&]v=([^?&#]+)/i.exec(u);
                if (/youtube\.com/i.test(u) && m) {
                    return 'https://www.youtube.com/embed/' + m[1] + '?autoplay=1';
                }

                m = /vimeo\.com\/(?:video\/)?(\d+)/i.exec(u);
                if (m) return 'https://player.vimeo.com/video/' + m[1] + '?autoplay=1';

                return u;
            } catch (err) {
                return href;
            }
        }

        (function ensureMagnificIframeVideoPatterns() {
            if (typeof $ === 'undefined' || !$.magnificPopup || !$.magnificPopup.defaults || !$.magnificPopup.defaults.iframe) {
                return;
            }
            /* Replace plugin defaults: generic `youtube.com` + id `v=` breaks /embed/… URLs (broken iframe / wrong layer). Order: most specific index first. */
            $.magnificPopup.defaults.iframe.patterns = {
                youtube_embed: {
                    index: 'youtube.com/embed',
                    id: function (url) {
                        var m = url.match(/embed\/([^?&#]+)/);
                        return m ? m[1] : '';
                    },
                    src: '//www.youtube.com/embed/%id%?autoplay=1'
                },
                youtube_watch: {
                    index: 'youtube.com/watch',
                    id: 'v=',
                    src: '//www.youtube.com/embed/%id%?autoplay=1'
                },
                youtube_shorts: {
                    index: 'youtube.com/shorts/',
                    id: function (url) {
                        var m = url.match(/shorts\/([^?&#]+)/);
                        return m ? m[1] : '';
                    },
                    src: '//www.youtube.com/embed/%id%?autoplay=1'
                },
                youtu_be: {
                    index: 'youtu.be/',
                    id: function (url) {
                        var m = url.match(/youtu\.be\/([^?&#]+)/);
                        return m ? m[1] : '';
                    },
                    src: '//www.youtube.com/embed/%id%?autoplay=1'
                },
                vimeo_player: {
                    index: 'player.vimeo.com/video/',
                    id: function (url) {
                        var m = url.match(/video\/(\d+)/);
                        return m ? m[1] : '';
                    },
                    src: '//player.vimeo.com/video/%id%?autoplay=1'
                },
                vimeo: {
                    index: 'vimeo.com/',
                    id: '/',
                    src: '//player.vimeo.com/video/%id%?autoplay=1'
                }
            };
        })();

        $(document).on('click', 'a.play-video', function (e) {
            if (typeof $.magnificPopup === 'undefined' || typeof $.magnificPopup.open !== 'function') {
                return;
            }
            var raw = $(this).attr('href');
            if (!raw) return;
            e.preventDefault();
            var src = normalizeExploreVideoSrc(raw);
            if (!src) return;
            $.magnificPopup.open({
                items: { src: src, type: 'iframe' },
                mainClass: 'mfp-fade',
                removalDelay: 160,
                fixedContentPos: true,
                closeBtnInside: true,
                closeOnContentClick: false,
                closeOnBgClick: true
            });
        });

          $(document).ready(function () {
            $(".star_table").each(function (index) {
              $(this).attr("data-index", index + 1);
            });
          
            $(".star_table").on("mouseenter", function () {
              let index = $(this).data("index");
              $(".star_table").each(function () {
                if ($(this).data("index") <= index) {
                  $(this).find(".str_white").addClass("d-none");
                  $(this).find(".str_black").removeClass("d-none");
                } else {
                  $(this).find(".str_white").removeClass("d-none");
                  $(this).find(".str_black").addClass("d-none");
                }
              });
            });
          
            $(".stars_ratings").on("mouseleave", function () {
              $(".star_table").find(".str_white").removeClass("d-none");
              $(".star_table").find(".str_black").addClass("d-none");
            });
          
            $(".star_table").on("click", function () {
              let index = $(this).data("index");
              $(".star_table").each(function () {
                if ($(this).data("index") <= index) {
                  $(this).find(".str_white").addClass("d-none");
                  $(this).find(".str_black").removeClass("d-none");
                } else {
                  $(this).find(".str_white").removeClass("d-none");
                  $(this).find(".str_black").addClass("d-none");
                }
              });
          
              $(".stars_ratings").attr("data-selected", index);
            });
          });

          
        // marquee js - prevent multiple initializations
        // Exclude partners marquee as it has its own initialization
        $('.marquee').not('[data-marquee-exclude="true"]').each(function() {
          // Check if this marquee is already initialized
          if (!$(this).data('marquee-initialized')) {
            $(this).marquee({
              duration: 30000,
              duplicated: true,
              pauseOnHover: true,
              gap: 0,
              startVisible: true,
              delayBeforeStart: 0,
            });
            // Mark as initialized
            $(this).data('marquee-initialized', true);
          }
        });
          

        function initOwlWhenVisible(selector, options, rootMargin) {
            var $els = $(selector);
            if (!$els.length || typeof $.fn.owlCarousel !== 'function') return;

            var initOne = function (el) {
                var $el = $(el);
                if ($el.data('owl-initialized')) return;
                $el.owlCarousel(options);
                $el.data('owl-initialized', true);
            };

            if (!('IntersectionObserver' in window)) {
                $els.each(function () { initOne(this); });
                return;
            }

            var observer = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (!entry.isIntersecting) return;
                    initOne(entry.target);
                    observer.unobserve(entry.target);
                });
            }, { rootMargin: rootMargin || '300px 0px' });

            $els.each(function () {
                observer.observe(this);
            });
        }

        /* Collection page text_slider (Owl): visible horizontal scrollbar synced with carousel */
        var textSliderScrollbarRegistry = [];
        var textSliderScrollbarResizeHooked = false;
        var textSliderSbResizeTimer = null;

        function hookTextSliderScrollbarResize() {
            if (textSliderScrollbarResizeHooked) return;
            textSliderScrollbarResizeHooked = true;
            $(window).on('resize.textsliderSb', function () {
                clearTimeout(textSliderSbResizeTimer);
                textSliderSbResizeTimer = setTimeout(function () {
                    textSliderScrollbarRegistry.forEach(function (fn) {
                        try {
                            fn();
                        } catch (err) { /* ignore */ }
                    });
                }, 120);
            });
        }

        function getTextSliderStageTranslateX(stageEl) {
            if (!stageEl) return 0;
            /* Owl animates via inline transform during drag; computed style can lag one frame. */
            var tr = stageEl.style.transform ||
                stageEl.style.webkitTransform ||
                stageEl.style.msTransform ||
                '';
            if (!tr || tr === 'none') {
                tr = window.getComputedStyle(stageEl).transform;
            }
            if (!tr || tr === 'none') return 0;
            var pxMatch = tr.match(/translate(?:3d|X)?\(\s*(-?[\d.]+)(?:px)?/i);
            if (pxMatch) {
                return parseFloat(pxMatch[1]);
            }
            var m = tr.match(/matrix(?:3d)?\(([^)]+)\)/);
            if (!m) return 0;
            var v = m[1].split(',').map(function (s) { return parseFloat(s.trim()); });
            return tr.indexOf('matrix3d') === 0 ? (v[12] || 0) : (v[4] || 0);
        }

        function initTextSliderScrollbar($carousel) {
            if (!$carousel || !$carousel.length) return;
            if ($carousel.data('text-slider-scrollbar-inited')) return;
            $carousel.data('text-slider-scrollbar-inited', true);

            var $bar = $(
                '<div class="text_slider_scrollbar">' +
                    '<div class="text_slider_scrollbar_row">' +
                        '<div class="text_slider_scrollbar_nav_slot text_slider_scrollbar_nav_slot--prev"></div>' +
                        '<div class="text_slider_scrollbar_track_wrap">' +
                            '<div class="text_slider_scrollbar_track">' +
                                '<button type="button" class="text_slider_scrollbar_thumb" aria-label="Scroll subcategories horizontally"></button>' +
                            '</div>' +
                        '</div>' +
                        '<div class="text_slider_scrollbar_nav_slot text_slider_scrollbar_nav_slot--next"></div>' +
                    '</div>' +
                '</div>'
            );
            $carousel.after($bar);
            var $track = $bar.find('.text_slider_scrollbar_track');
            var $thumb = $bar.find('.text_slider_scrollbar_thumb');

            function relocateTextSliderNav() {
                var $nav = $carousel.children('.owl-nav');
                if (!$nav.length) return;
                $bar.find('.text_slider_scrollbar_nav_slot--prev').empty().append($nav.find('.owl-prev'));
                $bar.find('.text_slider_scrollbar_nav_slot--next').empty().append($nav.find('.owl-next'));
                $nav.remove();
            }

            function syncTextSliderNavVisibility() {
                var $prev = $bar.find('.owl-prev');
                var $next = $bar.find('.owl-next');
                var navDisabled = !$prev.length || ($prev.hasClass('disabled') && $next.hasClass('disabled'));
                $bar.find('.text_slider_scrollbar_nav_slot').toggleClass('is-hidden', navDisabled);
            }

            setTimeout(function () {
                relocateTextSliderNav();
                syncTextSliderNavVisibility();
            }, 0);

            function getCore() {
                return $carousel.data('owl.carousel');
            }

            function getMetrics() {
                var $outer = $carousel.find('.owl-stage-outer');
                var $stage = $carousel.find('.owl-stage');
                var outerEl = $outer[0];
                var stageEl = $stage[0];
                var outerW = outerEl ? $outer.width() : 0;
                var stageW = stageEl ? $stage.width() : 0;
                var maxScroll = Math.max(0, stageW - outerW);
                var tx = getTextSliderStageTranslateX(stageEl);
                return { outerW: outerW, stageW: stageW, maxScroll: maxScroll, tx: tx };
            }

            function updateScrollbar() {
                /* While dragging the custom thumb, position comes from pointer — not Owl (indices round, so stage often stays put). */
                if ($carousel.data('text-slider-thumb-drag')) return;

                var m = getMetrics();
                if (!m.stageW || !$track[0]) return;

                if (m.maxScroll <= 1) {
                    $bar.addClass('text_slider_scrollbar--hidden').attr('aria-hidden', 'true');
                    syncTextSliderNavVisibility();
                    return;
                }
                $bar.removeClass('text_slider_scrollbar--hidden').attr('aria-hidden', 'false');
                syncTextSliderNavVisibility();

                var trackW = $track.width();
                var thumbW = Math.max(24, trackW * (m.outerW / m.stageW));
                thumbW = Math.min(thumbW, trackW);
                var progress = m.maxScroll > 0 ? Math.min(1, Math.max(0, (-m.tx) / m.maxScroll)) : 0;
                var maxThumbLeft = Math.max(0, trackW - thumbW);
                var thumbLeft = progress * maxThumbLeft;

                $thumb.css({
                    width: thumbW + 'px',
                    WebkitTransform: 'translateX(' + thumbLeft + 'px)',
                    transform: 'translateX(' + thumbLeft + 'px)'
                });
            }

            function scrollToProgress(progress, speed) {
                var core = getCore();
                if (!core || typeof core.maximum !== 'function') return;
                var maxIdx = core.maximum();
                if (maxIdx < 0) return;
                var idx = Math.round(Math.min(1, Math.max(0, progress)) * maxIdx);
                var sp = speed !== undefined ? speed : 250;
                $carousel.trigger('to.owl.carousel', [idx, sp]);
            }

            textSliderScrollbarRegistry.push(updateScrollbar);
            hookTextSliderScrollbarResize();

            /* While dragging the carousel (not the custom bar), sync thumb every frame — Owl updates inline transform between translate events. */
            var dragPollRaf = null;
            function stopDragPoll() {
                if (dragPollRaf != null) {
                    cancelAnimationFrame(dragPollRaf);
                    dragPollRaf = null;
                }
                updateScrollbar();
            }
            function dragPollLoop() {
                updateScrollbar();
                dragPollRaf = requestAnimationFrame(dragPollLoop);
            }

            $carousel.on('drag.owl.carousel', function () {
                stopDragPoll();
                dragPollRaf = requestAnimationFrame(dragPollLoop);
            });
            $carousel.on('dragged.owl.carousel', stopDragPoll);

            $carousel.on('translate.owl.carousel translated.owl.carousel refreshed.owl.carousel resized.owl.carousel', function () {
                updateScrollbar();
                relocateTextSliderNav();
                syncTextSliderNavVisibility();
            });
            setTimeout(updateScrollbar, 50);
            setTimeout(updateScrollbar, 320);

            $track.on('click', function (e) {
                if ($(e.target).closest('.text_slider_scrollbar_thumb').length) return;
                var rect = $track[0].getBoundingClientRect();
                var clickX = e.clientX - rect.left;
                var trackW = rect.width;
                var m = getMetrics();
                if (m.maxScroll <= 1) return;
                var thumbW = Math.max(24, trackW * (m.outerW / m.stageW));
                thumbW = Math.min(thumbW, trackW);
                var maxThumbLeft = Math.max(0, trackW - thumbW);
                var targetLeft = Math.max(0, Math.min(maxThumbLeft, clickX - thumbW / 2));
                var prog = maxThumbLeft > 0 ? targetLeft / maxThumbLeft : 0;
                scrollToProgress(prog);
            });

            var dragActive = false;
            function startDrag(clientX) {
                dragActive = true;
                $carousel.data('text-slider-thumb-drag', true);
                var trackRect = $track[0].getBoundingClientRect();
                var startClientX = clientX;
                var m0 = getMetrics();
                var trackW = trackRect.width;
                var thumbW = Math.max(24, trackW * (m0.outerW / m0.stageW));
                thumbW = Math.min(thumbW, trackW);
                var maxThumbLeft = Math.max(0, trackW - thumbW);
                var progress0 = m0.maxScroll > 0 ? (-m0.tx / m0.maxScroll) : 0;
                var startThumbLeft = progress0 * maxThumbLeft;

                function applyThumbPixels(leftPx) {
                    $thumb.css({
                        width: thumbW + 'px',
                        WebkitTransform: 'translateX(' + leftPx + 'px)',
                        transform: 'translateX(' + leftPx + 'px)'
                    });
                }

                function onMove(ev) {
                    if (!dragActive) return;
                    var cx = ev.clientX;
                    if (ev.type === 'touchmove') {
                        var te = (ev.originalEvent && ev.originalEvent.touches && ev.originalEvent.touches[0]) ||
                            (ev.touches && ev.touches[0]);
                        if (te) cx = te.clientX;
                    }
                    var dx = cx - startClientX;
                    var newLeft = Math.max(0, Math.min(maxThumbLeft, startThumbLeft + dx));
                    var prog = maxThumbLeft > 0 ? newLeft / maxThumbLeft : 0;
                    applyThumbPixels(newLeft);
                    scrollToProgress(prog, 0);
                }
                function onEnd() {
                    dragActive = false;
                    $carousel.removeData('text-slider-thumb-drag');
                    $(document).off('mousemove.textsliderSb touchmove.textsliderSb mouseup.textsliderSb touchend.textsliderSb');
                    updateScrollbar();
                }
                $(document).on('mousemove.textsliderSb touchmove.textsliderSb', onMove);
                $(document).on('mouseup.textsliderSb touchend.textsliderSb', onEnd);
            }

            $thumb.on('mousedown', function (e) {
                e.preventDefault();
                startDrag(e.clientX);
            });
            $thumb.on('touchstart', function (e) {
                var touches = (e.originalEvent && e.originalEvent.touches) || e.touches;
                if (!touches || touches.length !== 1) return;
                e.preventDefault();
                startDrag(touches[0].clientX);
            });

            $thumb.on('keydown', function (e) {
                if (e.key === 'ArrowLeft') {
                    e.preventDefault();
                    $carousel.trigger('prev.owl.carousel');
                } else if (e.key === 'ArrowRight') {
                    e.preventDefault();
                    $carousel.trigger('next.owl.carousel');
                }
            });
        }

        $(document).on('initialized.owl.carousel', '.text_slider', function (event) {
            var $carousel = $(event.target).closest('.text_slider');
            if (!$carousel.length) {
                $carousel = $(event.target);
            }
            initTextSliderScrollbar($carousel);
            var $tsBar = $carousel.next('.text_slider_scrollbar');
            $tsBar.find('.owl-prev').attr('aria-label', 'Previous subcategories');
            $tsBar.find('.owl-next').attr('aria-label', 'Next subcategories');
        });

        // hero_slider: init on DOM ready + rAF (not window.load) so main thread is free sooner for LCP paint.
        var initHeroSlider = function () {
            $('.hero_slider').each(function () {
                var $slider = $(this);
                if (!$slider.length || typeof $.fn.owlCarousel !== 'function') return;
                if ($slider.data('owl-initialized')) return;
                var intervalSeconds = parseInt($slider.data('autoplay-interval')) || 2;
                $slider.owlCarousel({
                    loop: true,
                    autoplay: true,
                    autoplayTimeout: intervalSeconds * 1000,
                    autoplayHoverPause: false,
                    nav: false,
                    dots: true,
                    items: 1,
                    animateOut: 'fadeOut',
                    animateIn: 'fadeIn',
                    smartSpeed: 1500,
                    mouseDrag: false,
                    touchDrag: false
                });
                $slider.data('owl-initialized', true);
            });
        };

        $(function () {
            if (typeof window.requestAnimationFrame === 'function') {
                requestAnimationFrame(initHeroSlider);
            } else {
                initHeroSlider();
            }
        });

        initOwlWhenVisible('.product_slider', {
            loop: false,
            autoplay: false,
            nav: false,
            dots: false,
            responsive: { 0: { autoWidth: true }, 576: { autoWidth: true }, 768: { items: 2 }, 992: { items: 3 }, 1280: { items: 4 } }
        });

        initOwlWhenVisible('.product_slider2', {
            loop: false,
            autoplay: false,
            nav: false,
            dots: false,
            responsive: { 0: { autoWidth: true }, 576: { autoWidth: true }, 768: { items: 2 }, 992: { items: 3 }, 1280: { items: 3 } }
        });

        initOwlWhenVisible('.reviews_slider', {
            loop: false,
            autoplay: false,
            nav: false,
            dots: false,
            autoWidth: false,
            margin: 16,
            responsive: { 0: { autoWidth: true }, 576: { autoWidth: true }, 768: { items: 2 }, 992: { items: 3 }, 1280: { items: 3 } }
        });

        initOwlWhenVisible('.blog_slider', {
            loop: false,
            autoplay: false,
            nav: false,
            dots: false,
            autoWidth: false,
            margin: 32,
            responsive: { 0: { autoWidth: true, margin: 16 }, 576: { autoWidth: true, margin: 16 }, 768: { items: 2 }, 992: { items: 3 }, 1280: { items: 3 } }
        });

        initOwlWhenVisible('.instagram_slider', {
            loop: false,
            autoplay: false,
            nav: false,
            dots: false,
            autoWidth: false,
            margin: 0,
            responsive: { 0: { items: 3 }, 576: { items: 3 }, 768: { items: 3 }, 992: { items: 4 }, 1280: { items: 4 } }
        });

        var cartArrowPrev = (window.cartSliderArrows && window.cartSliderArrows.prev) || '/assets/cart_arrow_left.svg';
        var cartArrowNext = (window.cartSliderArrows && window.cartSliderArrows.next) || '/assets/cart_arrow_right.svg';
        initOwlWhenVisible('.cart_slider', {
            loop: false,
            autoplay: false,
            nav: true,
            dots: false,
            autoWidth: true,
            margin: 40,
            navText: [
                '<img src="' + cartArrowPrev + '" class="custom_prev" alt="arrow">',
                '<img src="' + cartArrowNext + '" class="custom_next" alt="arrow">'
            ],
            responsive: { 0: { margin: 16 }, 576: { margin: 16 }, 768: { margin: 40 }, 992: { margin: 40 }, 1280: { margin: 40 } }
        });

        initOwlWhenVisible('.text_slider', {
            loop: false,
            autoplay: false,
            nav: true,
            dots: false,
            autoWidth: true,
            navText: [
                '<img src="' + cartArrowPrev + '" class="text_slider_nav_img" alt="" role="presentation">',
                '<img src="' + cartArrowNext + '" class="text_slider_nav_img" alt="" role="presentation">'
            ],
            // Let taps go to <a> links; Owl touch/mouse drag steals the first touch on mobile — use nav + scrollbar to pan.
            touchDrag: false,
            mouseDrag: false,
            pullDrag: false,
            responsive: { 0: { margin: 6 }, 576: { margin: 6 }, 768: { margin: 8 } }
        });

        initOwlWhenVisible('.category_slide_slider', {
            loop: false,
            autoplay: false,
            nav: false,
            dots: true,
            autoWidth: false,
            items: 1
        });

        // nice-select: postpone so it doesn't block initial render
        var initNiceSelect = function () {
            if (typeof $.fn.niceSelect !== 'function') return;
            var $selects = $('select').filter(function () {
                return !$(this).is('[data-no-nice-select]');
            });
            if ($selects.length) $selects.niceSelect();
        };

        if ('requestIdleCallback' in window) {
            requestIdleCallback(initNiceSelect, { timeout: 1200 });
        } else {
            setTimeout(initNiceSelect, 300);
        }


    });

})(jQuery);

(function () {
  function vendorBadgeFromEvent(event) {
    var target = event.target;
    if (!target || !target.closest) return null;
    return target.closest('.vendor-badge-link[data-vendor-url]');
  }

  document.addEventListener('pointerdown', function (event) {
    var badge = vendorBadgeFromEvent(event);
    if (!badge) return;
    event.preventDefault();
    event.stopPropagation();
  }, true);

  document.addEventListener('click', function (event) {
    var badge = vendorBadgeFromEvent(event);
    if (!badge) return;
    event.preventDefault();
    event.stopPropagation();
    window.location.assign(badge.dataset.vendorUrl);
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var badge = vendorBadgeFromEvent(event);
    if (!badge || document.activeElement !== badge) return;
    event.preventDefault();
    event.stopPropagation();
    window.location.assign(badge.dataset.vendorUrl);
  }, true);
})();
